import {db, uuid} from "../Database.svelte";
import {readable} from 'svelte/store';

export default class Dashboard {
    constructor (dashboard_id) {
        // If we are not providing a dashboard ID don't create base data;
        // This should only be used for calling class function with func.apply
        if (!dashboard_id) return;

        this.dashboard_id = dashboard_id;

        this.store = this.getDashboardStore();

        this.dashboard_data = {
            details: {
                name: "",
                fields: []
            },
            items: []
        }
    }

    getDashboardStore() {
        return readable(undefined, (set) => {
            db.allDocs({
                include_docs: true,
                startkey: `${this.dashboard_id}`,
                endkey: `${this.dashboard_id}:\ufff0`
            }).then((result) => {
                for (let row of result.rows) {
                    this.handleDoc(row);
                }
                set(this.dashboard_data);
            });

            let changeMonitor = db.changes({
                since: 'now',
                live: true,
                include_docs: true,
                filter: "filters/starts_with",
                query_params: {
                    id: this.dashboard_id
                }
            }).on("change", (change) => {
                this.handleDoc(change);
                set(this.dashboard_data);
            });

            return () => {
                changeMonitor.cancel();
            }
        });
    }

    handleDoc(row) {
        let id, type, rest;
        let item_id;

        if (row.id == this.dashboard_id) {
            this.dashboard_data.details = row.doc;
            return
        }

        [id, type, ...rest] = row.id.split(':');

        switch (type) {
            case "dashboardItem":
                item_id = rest[0];

                if (row.deleted) {
                    this.dashboard_data.items = this.dashboard_data.items.filter((c) => c._id != row.id);
                    break;
                }

                let found = false;
                this.dashboard_data.items =  this.dashboard_data.items.map((item) => {
                    if (item._id == row.id) {
                        found = true;
                        return row.doc;
                    } else {
                        return item;
                    }
                });

                if (!found) {
                    this.dashboard_data.items.push(row.doc)
                }

                break
        }
    }

    static getDashboardList() {
        let dashboard_list = [];

        return readable(undefined, (set) => {
            db.find({
                selector: {
                    type: 'dashboard'
                }
            }).then(results => {
                dashboard_list = results.docs;
                set(dashboard_list);
            })


            let changeMonitor = db.changes({
                since: "now",
                live: true,
                include_docs: true,
                filter: 'filters/doc_type',
                query_params: {
                    type: "dashboard"
                }
            }).on("change", (change) => {
                if (change.deleted) {
                    dashboard_list = dashboard_list.filter(dashboard => dashboard._id != change.id)
                } else {
                    let found = false;
                    dashboard_list = dashboard_list.map(dashboard => {
                        if (dashboard._id != change.id) return dashboard;
                        found = true;
                        return change.doc;
                    })

                    if (!found) dashboard_list.push(change.doc);
                }

                set(dashboard_list)
            });

            return () => changeMonitor.cancel();
        })
    }

    static async getDashboardListStatic() {
        let results = await db.find({
            selector: {
                type: "dashboard"
            }
        });

        return results.docs;
    }

    static async getDashboardStatic(dashboard_id) {
        let data = {
            dashboard_id: dashboard_id,
            dashboard_data: {
                details: {
                    name: "",
                    fields: []
                },
                items: []
            }
        }

        await db.allDocs({
            include_docs: true,
            startkey: `${dashboard_id}`,
            endkey: `${dashboard_id}:\ufff0`
        }).then((result) => {
            for (let row of result.rows) {
                (new Dashboard()).handleDoc.apply(data, [row]);
            }
        });

        return data;
    }

    static createDashboard(dashboard) {
        let new_dashboard = {
            _id: uuid(),
            type: "dashboard",
            name: dashboard.name,
            fields: []
        }

        return db.put(new_dashboard);
    }

    static deleteDashboard(dashboard_id) {
        return db.allDocs({
            include_docs: true,
            startkey: dashboard_id,
            endkey: `${dashboard_id}:\ufff0`
        }).then(result => {
            let docs_to_delete = [];
            for (let row of result.rows) {
                row.doc._deleted = true;
                docs_to_delete.push(row.doc);
            }

            return db.bulkDocs(docs_to_delete);
        })
    }

    static updateDashboard(dashboard) {
        return db.put(dashboard)
    }

    addItem(item) {
        let item_id = uuid();
        item._id = `${this.dashboard_id}:dashboardItem:${item_id}`
        item.item_id = item_id
        item.type = "dashboardItem"

        return db.put(item);
    }

    deleteItem(item) {
        item._deleted = true;
        db.put(item);
    }

    updateItem(item) {
        return db.put(item)
    }


}